// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n::-webkit-scrollbar {\r\n  width: 5px;\n}\r\n\r\n/* Track */\n[dir] ::-webkit-scrollbar-track {\r\n  background: #d5d8d0;\n}\r\n\r\n/* Handle */\n[dir] ::-webkit-scrollbar-thumb {\r\n  background: #d7fc93;\r\n  border-radius: 10px;\n}\r\n\r\n/* Handle on hover */\n[dir] ::-webkit-scrollbar-thumb:hover {\r\n  background: #d7fc93;\n}\r\n\r\n/* *{\r\n  outline: 0.5px solid red;\r\n} */\r\n", ""]);
// Exports
module.exports = exports;
